import { HomeyApiKind } from '../../lib/HomeyApiKind';

import type { DevicesStoreState } from './DevicesStore';

export function selectDevice(state: DevicesStoreState, deviceId: string) {
  // Keep the discriminator and its corresponding resources in the same union member.
  switch (state.apiKind) {
    case HomeyApiKind.V2:
      return selectPlatformDevice(state, deviceId);
    case HomeyApiKind.V3_LOCAL:
      return selectPlatformDevice(state, deviceId);
    case HomeyApiKind.V3_CLOUD:
      return selectPlatformDevice(state, deviceId);
    case null:
      return {
        apiKind: state.apiKind,
        device: null,
        deviceInstance: null,
        isLoading: state.isLoading,
        error: state.error,
      };
  }
}

function selectPlatformDevice<Kind extends HomeyApiKind, Instance, Props>(
  state: {
    apiKind: Kind;
    data: Record<string, Instance> | null;
    byId: Record<string, Props> | null;
    isLoading: boolean;
    error: unknown;
  },
  deviceId: string,
) {
  return {
    apiKind: state.apiKind,
    device: state.byId?.[deviceId] ?? null,
    deviceInstance: state.data?.[deviceId] ?? null,
    isLoading: state.isLoading,
    error: state.error,
  };
}
